import styled from 'styled-components';

export const ProvisionRigForm = styled.form`
  font-size: 1.5em;
  display: flex;
  flex-direction: column;
`;
